import { ExternalLink } from "lucide-react";

export default function GestionLink({ testId, className = "" }) {
  return (
    <a
      href="/gestion"
      data-testid={testId}
      className={`flex items-center gap-2 border border-white/40 px-4 py-2 text-xs font-mono-tactical uppercase tracking-wider font-semibold rounded hover:bg-white/10 transition-colors ${className}`}
    >
      <ExternalLink className="w-3.5 h-3.5" aria-hidden="true" />
      Gestión PCVigo
    </a>
  );
}
